import { createFileRoute, Outlet } from "@tanstack/react-router";
import { Sidebar } from "../../components/dashboard/Sidebar";

export const Route = createFileRoute("/organization/$slug")({
  component: OrgSlugLayout,
});

function OrgSlugLayout() {
  return (
    <div className="flex min-h-screen">
      <Sidebar />
      <main className="flex-1 p-8">
        <Outlet />
      </main>
    </div>
  );
}
